import React from "react";
import module from "./MostBottomButton.module.css";
import { Button } from "@mui/material";

const MostBottomButton = ({ label, handleClick, type = null, isBottom }) => {
  const bottomStyle = isBottom
    ? {
        position: "absolute",
        bottom: "0px",
        width: "100%",
      }
    : {};
  return (
    <div className={module.buttonContainer}>
      <Button
        variant="contained"
        color="primary"
        sx={{
          width: "100%",
          fontWeight: "bold",
          borderRadius: "0px",
          padding: "12px 0px",
          margin: "32px 0px",
          "@media (max-width: 640px)": {
            bottom: "0px",
            left: "0px",
            margin: "0px",
            ...bottomStyle,
          },
        }}
        type={type}
        onClick={handleClick}
      >
        {label}
      </Button>
    </div>
  );
};

export default MostBottomButton;
